/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {MdTable} from './table';
import {CdkTableModule} from '@angular/cdk/table';
import {MdCell, MdHeaderCell, MdCellDef, MdHeaderCellDef, MdColumnDef} from './cell';
import {MdHeaderRow, MdRow, MdHeaderRowDef, MdRowDef, MatHeaderRowDef, MatRowDef} from './row';
import {CommonModule} from '@angular/common';
import {MdCommonModule} from '@angular/material/core';
export class MdTableModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CdkTableModule, CommonModule, MdCommonModule],
  exports: [MdTable, MdCellDef, MdHeaderCellDef, MdColumnDef,
    MdHeaderRowDef, MdRowDef,
    MdHeaderCell, MdCell, MdHeaderRow, MdRow,
    MatHeaderRowDef, MatRowDef],
  declarations: [MdTable, MdCellDef, MdHeaderCellDef, MdColumnDef,
    MdHeaderRowDef, MdRowDef,
    MdHeaderCell, MdCell, MdHeaderRow, MdRow,
    MatHeaderRowDef, MatRowDef],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdTableModule_tsickle_Closure_declarations() {
/** @type {?} */
MdTableModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdTableModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
